import { useRouter } from 'found';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HelpIcon from '@mui/icons-material/HelpOutline';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import Badge from 'components/Badge';
import { Row } from 'components/Grid';
import useIsMobile from 'lib/useIsMobile';

const styles = {
  container: {
    position: 'fixed',
    width: '100vw',
    bottom: 0,
    zIndex: 1100,
    borderTop: '1px solid rgb(224, 224, 224)',
  },
};

const BottomNav = ({ links }) => {
  const mobile = useIsMobile();
  const { match: { location: { pathname } }, router } = useRouter();
  // const pathMatches = useCallback(
  //   link => link.path === pathname,
  //   [pathname],
  // );
  const onItemClick = useCallback(
    item => {
      if (item.handler) {
        item.handler();
      } else if (item.path) {
        router.push(item.path);
      }
    },
    [router],
  );
  const renderLink = useCallback(
    item => (
      <BottomNavigationAction
        key={item.path}
        value={item.path}
        icon={item.icon || <HelpIcon />}
        showLabel
        label={(
          <Badge count={item.badge}>
            {item.label}
          </Badge>
        )}
        onClick={() => onItemClick(item)}
      />
    ),
    [onItemClick],
  );
  return mobile && links
    ? (
      <Row style={styles.container}>
        <BottomNavigation style={styles.container} value={pathname}>
          {links.map(renderLink)}
        </BottomNavigation>
      </Row>
    )
    : null;
};

BottomNav.propTypes = {
  links: PropTypes.array,
};

export default BottomNav;
